<template>
  <div
    v-if="model !== null && model.children.length > 0"
    class="row column"
    data-test-claim-question-tree-category
  >
    <h1 :id="id">
      {{ model.title }}
    </h1>
    <div class="grid-container">
      <div class="grid-x grid-padding-x small-up-1 medium-up-2 large-up-3 main-links__links main-links__paragraph">
        <item
          v-for="(subItem, index) in model.children"
          :key="index"
          :index="categoryIndex"
          class="cell column"
          data-test-claim-question-tree-category-item
          :item="subItem"
          :link="link"
          :is-car-leased="subItem.isCarLeased"
          @register="$emit('register', $event)"
          :selected-policy="selectedPolicy"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Item from './Item.vue';

export default {
    name: 'Category',
    components: { Item },
    props: {
        model: {
            type: Object,
            default: null
        },
        id: {
            type: String,
            default: ''
        },
        link: {
            type: String,
            default: ''
        },
        categoryIndex: {
            type: Number,
            default: null
        },
        selectedPolicy: {
            type: Object,
            default: () => {
                return {
                  isActive: null,
                  isCarLeased: null
                };
            }
        }
    }
};
</script>
